import { useState, useEffect } from "react";

// 2026/27 opening weekend: Fri 21 Aug 2026, 20:00 BST (19:00 UTC) — Arsenal v Coventry.
export const SEASON_KICKOFF = new Date("2026-08-21T19:00:00Z");

function fmt(diff) {
  const mins = Math.floor(diff / 60000);
  const d = Math.floor(mins / 1440), h = Math.floor((mins % 1440) / 60), m = mins % 60;
  return d > 0 ? `${d}d ${h}h ${m}m` : h > 0 ? `${h}h ${m}m` : `${m}m`;
}

const Pill = ({ children, className, testid }) => (
  <div
    data-testid={testid}
    className={`inline-flex items-center gap-2 border-2 border-primary bg-primary/10 px-3 py-1.5 ${className}`}
  >
    <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
    <span className="font-data text-[10px] sm:text-xs uppercase tracking-[0.18em] text-foreground">{children}</span>
  </div>
);

// Generic countdown to any target Date.
export const Countdown = ({ target, label = "Kicks off in", liveLabel = "Kicking off now", className = "", testid = "countdown" }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, []);
  const diff = target.getTime() - now;
  return (
    <Pill className={className} testid={testid}>
      {diff > 0
        ? <>{label} <span className="text-primary font-bold" data-testid={`${testid}-value`}>{fmt(diff)}</span></>
        : <span className="text-primary font-bold">{liveLabel}</span>}
    </Pill>
  );
};

export const SeasonCountdown = ({ className = "" }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, []);
  const diff = SEASON_KICKOFF.getTime() - now;
  return (
    <Pill className={className} testid="season-countdown">
      {diff > 0
        ? <>New season kicks off in <span className="text-primary font-bold" data-testid="season-countdown-value">{fmt(diff)}</span></>
        : <span className="text-primary font-bold">Season 2026/27 is live — get predicting</span>}
    </Pill>
  );
};
